import type {Poster} from '@PosterWhiteboard/poster/poster.class';
import type {UserPreferences} from '@/reducers/user-preferences.reducer';

export enum GlobalPosterEditorJqueryElement {
  WHITEBOARD_CONTAINER = 'WHITEBOARD_CONTAINER',
  POSTER_EDITOR_MOBILE_BOTTOM_EDITING_BAR = 'POSTER_EDITOR_MOBILE_BOTTOM_EDITING_BAR',
  POSTER_EDITOR_NAVBAR = 'POSTER_EDITOR_NAVBAR',
  WHITEBOARD = 'WHITEBOARD',
  POST_POSTER_ELEMENT = 'POST_POSTER_ELEMENT',
  POSTER_HORIZONTAL_SCROLL = 'POSTER_HORIZONTAL_SCROLL',
  POSTER_VERTICAL_SCROLL = 'POSTER_VERTICAL_SCROLL',
  POSTER_EDITOR_WEB_BOTTOM_BAR = 'POSTER_EDITOR_WEB_BOTTOM_BAR',
  EDITOR_WITHOUT_NAV = 'EDITOR_WITHOUT_NAV',
}

export const COPY_STYLES_COOKIE = 'pmwcsc';

export enum ElementToHide {
  DOWNLOAD = 'download',
  FILE = 'file',
  UPGRADE = 'upgrade',
}

export interface PosterEditor {
  whiteboard?: Poster;
  config?: PosterEditorConfig;
  elements: Partial<Record<GlobalPosterEditorJqueryElement, JQuery>>;
}

export interface PosterEditorConfig {
  imageDownlaodCostInCredits: number;
  videoDownloadCostInCredits: number;
  gettyFormattedDownloadCostForNonPremiumUsers: string;
  isSpellCheckAvailable: boolean;
  userPreferences: UserPreferences;
  hasPublishedUsingDigitalDisplay: boolean;
  elementsToHide?: ElementToHide[];
  nextBtnCaption?: string;
  showSuperUserOptions?: boolean;
  idOrder?: string;
  showOnBoardingPopups?: boolean;
  showMediaOnboardingPopup?: boolean;
  showMobileUXOnBoarding?: boolean;
  businessProfileUrl?: string;
  isInReview?: boolean;
  isPosterShared?: boolean;
  isPosterSharedInTeam?: boolean;
  featureToShowOnLoad: FeatureToShowOnLoad;
  featureDemo?: FeatureDemo;
}

export enum FeatureToShowOnLoad {
  NONE = 'NONE',
  TEMPLATE_POPUP = 'TEMPLATE_POPUP',
  AUDIO_RECORDING = 'AUDIO_RECORDING',
  VIDEO_RECORDING = 'VIDEO_RECORDING',
  AI_VOICE = 'AI_VOICE',
  AI_IMAGE = 'AI_IMAGE',
  AI_TEXT_ART = 'AI_TEXT_ART',
  AI_SUBTITLE = 'AI_SUBTITLE',
  AI_VIDEO = 'AI_VIDEO',
  AI_REMOVE_BG = 'AI_REMOVE_BG',
  MENU_MAKER = 'MENU_MAKER',
  STICKERS = 'STICKERS',
}

export enum FeatureDemo {
  NONE = 'NONE',
  MENU_MAKER = 'menu_maker',
  STICKERS = 'stickers',
  ANIMATIONS = 'animations',
  STYLES = 'styles',
  QR_CODE = 'qr_code',
}

export const EDITOR_SMALL_SCREEN_WIDTH_THRESHOLD = 780;
export const EDITOR_COLLAPSABLE_SIDEBAR_THRESHOLD = 900;
export const DESIGN_EDITOR_ONBOARDING_COOKIE = 'pmwne_onboarding';
export const POSTER_EDITOR_NAVBAR_HEIGHT = 60;

export enum MobilePageSelectionModeState {
  INACTIVE = 'inactive',
  TRANSITIONING = 'transitioning',
  ACTIVE = 'active',
}
